import * as React from "react";
import ImageContentCardLight from "components/partials/parts/image-content-card-light";
import IntroHeadline from "components/partials/parts/intro-headline";
import { IntroHeadlineProps } from "types/intro-headline-props";
import { ImageContentCardData } from "types/image-content-card-data";


type LightImageCardsProps = {
    intro?: IntroHeadlineProps;
    cards?: ImageContentCardData[] | undefined;
    columns: number;
};

const LightImageCards: React.FC<LightImageCardsProps> = ({ intro, cards, columns }) => (
    <div className="pattern">
        <div className="container">
            {intro &&
                <IntroHeadline {...intro} />
            }

            <div className={`flex-grid-container flex-grid-container--${columns}up`}>
                {cards && cards.map((card, i) => (
                        <ImageContentCardLight
                            columns={columns}
                            cardImage={card.cardImage}
                            headline={card.headline}
                            subtext={card.subtext}
                            buttonText={card.buttonText}
                            buttonUrl={card.buttonUrl}
                            buttonUrlTarget={card.buttonUrlTarget} key={i} />
                ))}
            </div>
        </div>
    </div>
);

export default LightImageCards;